
import './App.css';
import CountriesTables from './components/CountriesTables';

function App() {
  return (
    <div className="App">
      <h1>React Datatable</h1>
     <CountriesTables />
    </div>
  );
}

export default App;
